import { render, staticRenderFns } from "./AdminShareSettings.vue?vue&type=template&id=1b12d328&"
import script from "./AdminShareSettings.vue?vue&type=script&lang=js&"
export * from "./AdminShareSettings.vue?vue&type=script&lang=js&"
import style0 from "./AdminShareSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports